import {
  FormattableDisplayField,
} from 'core-app/shared/components/fields/display/field-types/formattable-display-field.module';

export class ExtendedFormattableDisplayField extends FormattableDisplayField {
  public render(element:HTMLElement, displayText:string, options:any = {}):void {
    if (this.context.container != 'single-view') {
      displayText = displayText.trim()
      let truncateIndex = displayText.indexOf("\n")
      if (truncateIndex > 0) {
        displayText = displayText.slice(0, truncateIndex)
        displayText += "\n..."
      }
    }
    super.render(element, displayText, options)
  }

  get placeholder():string {
    if (this.name === 'description' && this.context.container == 'single-view') {
      return this.I18n.t('js.placeholders.description');
    }

    return '-';
  }
}
